var map = {
	"./backgrounds/claim-four-bg.png": 3961,
	"./backgrounds/claim-four-bg.webp": 9617,
	"./backgrounds/claim-one-bg.png": 6689,
	"./backgrounds/claim-one-bg.webp": 3407,
	"./backgrounds/claim-three-bg.png": 6699,
	"./backgrounds/claim-three-bg.webp": 8572,
	"./backgrounds/claim-two-bg.png": 9073,
	"./backgrounds/claim-two-bg.webp": 6976,
	"./backgrounds/infography.svg": 6698,
	"./backgrounds/numbers-bg.png": 2843,
	"./backgrounds/numbers-bg.webp": 800,
	"./backgrounds/rain.svg": 4805,
	"./drops/drop1.png": 4754,
	"./drops/drop1.webp": 8062,
	"./drops/drop2.png": 4128,
	"./drops/drop2.webp": 9559,
	"./drops/drop3.png": 6304,
	"./drops/drop3.webp": 5775,
	"./drops/drop4.png": 2302,
	"./drops/drop4.webp": 9274,
	"./recycling/bottle-mag-2.png": 6946,
	"./recycling/bottle-mag-2.webp": 692,
	"./recycling/bottle.svg": 117,
	"./recycling/glass-mag-2.png": 826,
	"./recycling/glass-mag-2.webp": 2725,
	"./recycling/glass.svg": 4964,
	"./recycling/pack-mag.png": 2560,
	"./recycling/pack-mag.webp": 5459,
	"./recycling/pack.svg": 5088,
	"./stamp/stamp.svg": 7523
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5907;